/**
 * Created by Prodaja1 on 12.5.2017..
 */
import { Component } from '@angular/core';
import {NavController, NavParams} from 'ionic-angular';
import { Question3 } from '../question3/question3';
import {UserData} from "../services/UserData";
import { AlertController } from 'ionic-angular';


@Component({
    selector: 'question2',
    templateUrl: 'question2.html'
})
export class Question2 {
    userData: UserData;
    constructor(public navCtrl: NavController, public navParams : NavParams, private alertCtrl: AlertController) {
            this.userData=navParams.data;
    }

    // checkGradesValues () {
    //     if (this.userData.answer2 == '') {
    //         let alert = this.alertCtrl.create({
    //             title: 'Error',
    //             subTitle: 'Please fill in the field',
    //             buttons: ['OK']
    //         });
    //         alert.present();
    //     }
    //     else {
    //         this.navCtrl.push(Question3, this.userData);
    //     }
    // }

    checkCommentInput() {
        if (this.userData.answer2a!="Nezadovoljni") {
            this.userData.answer2b = '';
            return true;
        }
        else {
            return false;

        }
    }

    checkGradesValues () {
        if (this.userData.answer2a=='')
        {
            let alert = this.alertCtrl.create({
                title: 'Error',
                subTitle: 'Please select one of the options',
                buttons: ['OK']
            });
            alert.present();
        }
        else { //ako je oznaceno nesto od bulleta provjeri je li oznacen not satisfied.. Ako je onda je komentar obavezan, a ako nije onda ide na sljedecu stranicu
            if (this.userData.answer2a=='Nezadovoljni') {
                if (this.userData.answer2b=='') {
                    let alert = this.alertCtrl.create({
                        title: 'Error!',
                        subTitle: 'Please state a reason',
                        buttons: ['OK']
                    });
                    alert.present();
                }
                else {
                    this.navCtrl.push(Question3, this.userData);
                }
            }
            else {
                this.navCtrl.push(Question3, this.userData);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/question2/question2.ts